<mat-chip-list>
  <mat-chip size="sm" class="sharedChip" *ngIf="object.isShared">
    <div class="sharedChipTextBox">
      <span>{{ 'common.shared' | t }}</span>
    </div>
  </mat-chip>
  <mat-chip size="sm" *ngIf="!object.isShared" class="notSharedChip">
    <div class="notSharedChipTextBox">
      <span>{{ 'common.notShared' | t }}</span>
    </div>
  </mat-chip>
</mat-chip-list>
